const $selector = $('.js-pickup');

const pickup = {
  initialize() {
    if ($selector.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $selector.on('click', (e) => {
      e.preventDefault();
    });
  },
};

export default pickup;
